import dayjs from "dayjs";
import dayjsFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import { DB_DATE_FORMAT } from "@utils/core";
import type { DbDateString } from "@openings/api-client";

dayjs.extend(dayjsFormat);
dayjs.extend(duration);

export const formatDate = (date: Date): DbDateString =>
  dayjs(date).format(DB_DATE_FORMAT) as DbDateString;

export const getDatesBetween = (
  startDate: DbDateString,
  endDate: DbDateString,
): Date[] => {
  const dates: Date[] = [];
  let currentDate = dayjs(startDate, DB_DATE_FORMAT);
  const end = dayjs(endDate, DB_DATE_FORMAT);

  while (currentDate.isBefore(end) || currentDate.isSame(end)) {
    dates.push(currentDate.toDate());
    currentDate = currentDate.add(1, "day");
  }

  return dates;
};

export const formatMinutes = (minutes: number): string | null => {
  if (!minutes) return null;

  const formatted = dayjs.duration(minutes, "minutes");
  const hours = formatted.hours();
  const mins = formatted.minutes();

  if (hours && mins) {
    return `${hours} hr${hours > 1 ? "s" : ""} ${mins} min${
      mins > 1 ? "s" : ""
    }`;
  }
  if (hours) {
    return `${hours} hr${hours > 1 ? "s" : ""}`;
  }
  if (mins) {
    return `${mins} min${mins > 1 ? "s" : ""}`;
  }
  return "0 mins";
};
